import React from 'react';
import ManagementGatewayCockpitInsightsEdges from './edge/containers/edges';
import ManagementGatewayCockpitInsightsNPs from './network-participant/containers/network-paticipants';
import ManagementGatewayLogs from './gateway-logs/containers/gateway-logs';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';







export const CommunityComponent = ({   }: any) => {
 
   
  const tabItems = [
  {
            id: 1,
            title: 'Edge',
            component: <ManagementGatewayCockpitInsightsEdges />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'Network Participants',
            component: <ManagementGatewayCockpitInsightsNPs />,
            isVisible: true,
        },
        {
            id: 3,
            title: 'Providers',
            component: <></>,
            isVisible: true,
        },
        {
            id: 4,
            title: 'Gateway Logs',
            component: <ManagementGatewayLogs />,
            isVisible: true,
        },        

  ]

  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">


      <TabContainer tabItems={tabItems} />

    
    </div>
  )
}
export default CommunityComponent;